module.exports = __webpack_public_path__ + "media/images/oak/aboutus-bd5f3c22722b522b4fda640a0f8b781e.jpg";